import React from 'react';
import styles from './TransmissionsChartSkeleton.module.css';

const TransmissionsChartSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}></div>
        <div className={styles.actions}>
          <div className={styles.viewToggle}>
            <div className={styles.viewOption}></div>
            <div className={styles.viewOption}></div>
          </div>
          <div className={styles.filterButton}>
            <div className={styles.filterIcon}></div>
          </div>
        </div>
      </div>

      <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <div className={styles.statLabel}></div>
          <div className={styles.statValue}></div>
          <div className={styles.statProgress}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: '75%' }}></div>
            </div>
            <div className={styles.progressValue}></div>
          </div>
        </div>
        
        <div className={styles.statCard}>
          <div className={styles.statLabel}></div>
          <div className={styles.statValue}></div>
          <div className={styles.statProgress}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: '45%' }}></div>
            </div>
            <div className={styles.progressValue}></div>
          </div>
        </div>
        
        <div className={styles.statCard}>
          <div className={styles.statLabel}></div>
          <div className={styles.statValue}></div>
          <div className={styles.statProgress}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: '30%' }}></div>
            </div>
            <div className={styles.progressValue}></div>
          </div>
        </div>
      </div>

      <div className={styles.chartArea}>
        <div className={styles.chartHeader}>
          <div className={styles.chartTitle}></div>
          <div className={styles.chartFilters}>
            <div className={styles.filterPill}></div>
            <div className={styles.filterPill}></div>
            <div className={styles.filterPill}></div>
          </div>
        </div>
        
        <div className={styles.chartContent}>
          <div className={styles.yAxis}>
            {[...Array(5)].map((_, i) => (
              <div key={`y-${i}`} className={styles.yAxisLabel}></div>
            ))}
          </div>
          
          <div className={styles.chart}>
            <div className={styles.gridLines}>
              {[...Array(5)].map((_, i) => (
                <div key={`grid-${i}`} className={styles.gridLine}></div>
              ))}
            </div>
            
            <div className={styles.barsContainer}>
              {[...Array(8)].map((_, i) => (
                <div key={`bar-group-${i}`} className={styles.barGroup}>
                  <div 
                    className={`${styles.bar} ${styles.primaryBar}`} 
                    style={{ height: `${Math.min(90, 30 + (i * 10))}%` }}
                  ></div>
                  <div 
                    className={`${styles.bar} ${styles.secondaryBar}`} 
                    style={{ height: `${Math.min(70, 20 + (i * 8))}%` }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className={styles.xAxis}>
          {[...Array(8)].map((_, i) => (
            <div key={`x-${i}`} className={styles.xAxisLabel}></div>
          ))}
        </div>
        
        <div className={styles.legend}>
          <div className={styles.legendItem}>
            <div className={styles.legendColor}></div>
            <div className={styles.legendText}></div>
          </div>
          <div className={styles.legendItem}>
            <div className={styles.legendColor}></div>
            <div className={styles.legendText}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransmissionsChartSkeleton;
